import React, { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from 'features/auth/store/authStore'
import axiosInterceptorInstance from '../../../utils/axios/axiosInterceptorInstance'

export default function PublicRoute() {
  const { token } = useAuth()

  const adminToken = new URLSearchParams(window.location.search).get(
    'adminToken',
  )

  const specifyRole = new URLSearchParams(window.location.search).get(
    'specify-role',
  )
  const goToHome = token && !adminToken && !specifyRole

  const [isTermsAvailable, setIsTermsAvailable] = useState(false)
  const [termsData, setTermsData] = useState(null)

  useEffect(() => {
    const checkTerms = async () => {
      try {
        const res = await axiosInterceptorInstance.get('/terms/active')

        if (res?.data?.activeTerms) {
          setTermsData(res.data?.activeTerms)
          setIsTermsAvailable(true)
        } else {
          setTermsData(null)
        }
      } catch {
        setTermsData(null)
      }
    }

    checkTerms()
  }, [])

  return goToHome ? (
    <Navigate to='/' replace />
  ) : (
    <Outlet context={{ isTermsAvailable, termsData }} />
  )
}
